import CheckIcon from "../CheckIcon";
import SpinnerIcon from "../SpinnerIcon";
import ErrorIcon from "../ErrorIcon";
import Input from "./components/Input";
import useForm, { Validations } from "./hooks/useForm";
import { isEmail, isPhone, isRequired } from "./validations/formValidations";
import emailjs from "@emailjs/browser";
import toast, { ToastBar, Toaster } from "react-hot-toast";
import { Divider } from "@heroui/react";

type FormValues = {
  company: string;
  name: string;
  email: string;
  phone: string;
  message: string;
};

(function () {
  emailjs.init({
    publicKey: import.meta.env.VITE_EMAILJS_KEY,
  });
})();

function sendEmail(templateParams: FormValues) {
  return emailjs.send(
    import.meta.env.VITE_EMAILJS_SERVICE_ID,
    import.meta.env.VITE_EMAILJS_TEMP_ID,
    templateParams
  );
}

const formValues: FormValues = {
  company: "",
  name: "",
  email: "",
  phone: "",
  message: "",
};

const validations: Validations<FormValues> = {
  company: [[isRequired, "Empresa es requerido"]],
  name: [[isRequired, "Nombre es requerido"]],
  email: [
    [isRequired, "Email es requerido"],
    [isEmail, "Email inválido"],
  ],
  phone: [
    [isRequired, "Número es requerido"],
    [isPhone, "Número inválido"],
  ],
  message: [[isRequired, "Message es requerido"]],
};

export default function Form() {
  const { values, errors, handleChange, handleSubmit, resetForm } =
    useForm<FormValues>(formValues, validations);

  const onSubmit = async (data: FormValues) => {
    try {
      const emailPromise = sendEmail(data);

      toast.promise(emailPromise, {
        loading: "Enviando email...",
        success: "Enviado",
        error: "No se pudo enviar el email. Inténtalo de nuevo más tarde",
      });

      await emailPromise;

      resetForm();
    } catch (error) {
      console.error("error", error);
    }
  };

  return (
    <div className="w-full h-full bg-white shadow-xl px-4 sm:px-6 md:px-0 lg:px-[70px] py-8 relative">
      <div className="w-full p-4 sm:p-6 md:p-10 text-lg" id="contact">
        <div className="w-full">
          <h2 className="font-medium sm:text-2xl md:text-3xl pb-2">
            Solicita más información
          </h2>
          <Divider/>
          <h5 className="text-2xl sm:text-base text-justify">
            Nuestros agentes de ventas se pondran en contacto contigo para brindarte una
            cotización personalizada, de acuerdo con las necesidades de tu
            proyecto.
          </h5>
        </div>
        <form
          onChange={handleChange}
          onSubmit={handleSubmit(onSubmit)}
          className="w-full mt-[30px] flex flex-col gap-[21px] relative"
        >
          <Toaster
            position="top-right"
            toastOptions={{ style: { padding: 0 } }}
          >
            {(t) => (
              <ToastBar toast={t}>
                {({ message }) => (
                  <div className="px-4 py-3 rounded-lg text-primary font-bold border-primary border-2">
                    {t.type === "success" && (
                      <div className="flex items-center gap-1">
                        <CheckIcon />
                        { message }
                      </div>
                    )}
                    {t.type === "error" && (
                      <div className="flex items-center gap-1">
                        <ErrorIcon />
                        { message }
                      </div>
                    )}
                    {t.type === "loading" && (
                      <div className="flex items-center gap-1">
                        <SpinnerIcon />
                        { message }
                      </div>
                    )}
                  </div>
                )}
              </ToastBar>
            )}
          </Toaster>
          <div className="flex flex-col sm:flex-row gap-[21px] w-full ">
            <Input
              name="company"
              placeholder="Empresa"
              value={values.company}
              error={errors.company}
            />
            <Input
              name="name"
              placeholder="Nombre"
              value={values.name}
              error={errors.name}
            />
          </div>
          <Input
            name="email"
            placeholder="Email"
            type="email"
            value={values.email}
            error={errors.email}
          />
          <Input
            name="phone"
            placeholder="Número telefónico"
            type="tel"
            value={values.phone}
            error={errors.phone}
          />
          <Input
            name="message"
            placeholder="Mensaje"
            as="textarea"
            value={values.message}
            error={errors.message}
          />
          <button className="button-form bg-[#C5A537] hover:bg-primary rounded-2xl hover:text-white hover:text-3xl ">Contactanos!</button>
          <img
            src={"/vegan/iso_zoom.webp"}
            alt={"logo"}
            className="w-auto h-[60px] object-contain"
          />
        </form>
      </div>
    </div>
  );
}
